import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteAward: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string) => Promise<void> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/awards/${awardId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete award', false));
